import React, { useState } from 'react';
import { Modal, Button } from 'react-bootstrap';

const PreviewModal = ({ entry, show, onClose }) => {
  const [copied, setCopied] = useState(false);

  if (!entry) return null;

  const handleCopy = () => {
    navigator.clipboard.writeText(entry.thumbnail_url || entry.path).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 1500);
    });
  };

  return (
    <Modal show={show} onHide={onClose} size="lg">
      <Modal.Header closeButton>
        <Modal.Title>{entry.name}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="text-center">
        {entry.is_image && (
          <img src={entry.thumbnail_url} alt={entry.name} style={{ maxWidth: '100%', maxHeight: 400 }} />
        )}
        <div className="mt-3">
          <code>{entry.path}</code>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>Close</Button>
        <Button onClick={handleCopy}>{copied ? 'Copied!' : 'Copy Path/URL'}</Button>
      </Modal.Footer>
    </Modal>
  );
};

export default PreviewModal;
